import { gql } from "@apollo/client";

export const blockchainAnimalFragment = gql`
  fragment blockchainAnimalFragment on BlockchainAnimalData {
    movements {
      createdBy
      fromFarmName
      fromHoldingId
      toOwnerId
      toOwnerName
      toHoldingId
      date
    }
    weights {
      date
      value
      unit
      holdingId
      createdBy
    }
    medication {
      date
      medicineName
      batchNumber
      dosage
      dosageUnits
      activeIngredient
      withdrawalDays
      holdingId
      createdBy
    }
    carcassGrading {
      date
      hotWeight
      coldWeight
      grading
      fatScore
      conformation
      condemnedWeight
      value
      killNumber
      lotNumber
      createdBy
      holdingId
    }
    breed
    dob
    isMale
    name
    ownerId
    ownerName
    ownerHoldingId
    passportNumber
    isDead
    deathDate
    deathCreatedBy
    error
  }
`;
